import { mapMutations } from 'vuex';

const validateResourceMixin = {
  data() {
    return {
      validating: false
    };
  },
  methods: {
    ...mapMutations('global', ['storeGlobalState']),
    validateResource(route, formData) {
      this.validating = true;

      return this.$http
        .post(route, formData)
        .then(
          () => {
            this.validating = false;

            return true;
          },
          error => {
            this.validating = false;

            if (error && error.response && error.response.status === 422) {
              this.storeGlobalState({
                validationErrors: error.response.data
              });
            }

            return false;
          }
        );
    }
  }
};

export default validateResourceMixin;
